'use strict';

import {EwSiteApp} from '../../app/ewsiteapp';
import 'jquery.cookie';

EwSiteApp.controller('gasCalcCtrl', ['$scope', '$filter', function ($scope, $filter) {
		$scope.output = 'html';
		$scope.scope = 'all';

		$scope.gas_form = function () {
			var $form = $('#gas_calc_form');
			$(".gas_value_level label").click(function () {
				$(".gas_value_level label").removeClass("active");
				$(this).addClass("active");
			});

			$form.submit(function (e) {
				if ($form.hasClass('loading')) {
					return false;
				}
				
				if ($scope.output === 'html') {
					$form.addClass('loading').find('.gas_spinner').show();
				}

				var fileDownloadCheckTimer;
				if ($scope.output !== 'html') {
					var token = (new Date().getTime()) + '';
					$('#download_token', $form).val(token);
					fileDownloadCheckTimer = setInterval(function () {
						var cookie = $.cookie('fileDownloadToken');
						if (cookie === token || cookie === 'done') {
							clearInterval(fileDownloadCheckTimer);
							$.removeCookie('fileDownloadToken', {path: '/'});
						$form.removeClass('loading').find('.gas_spinner').hide();
						}
					}, 500);

					return true;
				}

				var url = $(this).attr("action");
				$.ajax({
					type: "POST",
					url: url,
					data: $form.serialize(),
					success: function (data) {
						$("#gas_calc_results").html(data);
					},
					complete: function () {
					$form.removeClass('loading').find('.gas_spinner').hide();
					}
				});
				e.preventDefault();
			});

		};

		$scope.gas_form();
	}]);

EwSiteApp.directive('toggleCheckboxes', function () {
	return {
		restrict: 'A',
		link: function (scope, element) {
			const leadCityCheckbox = element.find('input[type="checkbox"]').eq(0);
			leadCityCheckbox.on('change', function () {
				const isChecked = leadCityCheckbox.prop('checked');
				element.find('.smaller_cities input[type="checkbox"]').prop('checked', isChecked);
			});
		}
	};
});
